import ReturnsRmaSlide from './ReturnsRmaSlide';
import { connect } from 'react-redux';
import { returnsActions } from 'src/store/modules/returns';
import {
  IReturnSubmittedOption,
  IReturnEditedOption,
  IStatusFilter,
  IReturnGenerateShippingLabel
} from 'src/services/returns/typings';
import { IInitialState } from 'src/store/initialState';

const mapStateToProps = (state: IInitialState) => ({});

const mapDispatchToProps = (dispatch: any) => ({
  onSubmitAfterEditRmaList: (
    config: IReturnSubmittedOption,
    callback?: () => void
  ) => {
    dispatch(returnsActions.onSubmitAfterEditRmaList(config, callback));
  },

  onSaveAfterEditRmaList: (
    config: IReturnEditedOption,
    callback?: () => void
  ) => {
    dispatch(returnsActions.onSaveAfterEditRmaList(config, callback));
  },

  getStatusItems: (body?: IStatusFilter) => {
    dispatch(returnsActions.getStatusItems(body));
  },

  onGenerateShippingLabel: (upsRequest: IReturnGenerateShippingLabel, callback?: () => void) => {
    dispatch(returnsActions.onGenerateShippingLabel(upsRequest, callback));
  },

  getRMALists: (body?: IStatusFilter) => {
    dispatch(returnsActions.getRMALists(body));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ReturnsRmaSlide);
